module.exports = __webpack_public_path__ + "img/crossBlack.47f96d1f.svg";